module.exports = __webpack_public_path__ + "img/profile-default.1c441d0d.jpg";